export default __webpack_public_path__ + "media/samples/FUNDEMANTALS_01-8d079814.jpg";